import { Action } from '@ngrx/store';
import { ILocationConfigUnit } from '../../models/location-config.interface';

export const LOAD_INITIAL_STATE = '[Special Instructions] Load initial state';
export const SET = '[Special Instructions] Set';

/**
 * Loads the initial state (but not value) of the special-instructions form-field.
 */
export class SpecialInstructionsLoadInitialState implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor(public payload: ILocationConfigUnit) {}
}

export class SpecialInstructionSetAction implements Action {
  readonly type = SET;

  constructor(public payload: string) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type SpecialInstructionsActions = SpecialInstructionSetAction | SpecialInstructionsLoadInitialState;
